// extracted by mini-css-extract-plugin
export default {"root":"file-explorer_root__t0i3n"};